<template>
  <a-modal
    :visible="visible"
    title="预览报告"
    style="top: 20px"
    :footer="null"
    @cancel="closePreview"
    :destroyOnClose="true"
    :maskClosable="false"
    width="900px"
    :bodyStyle="{ height: 'calc(100vh - 130px)' }"
  >
    <div v-loading="loading">
      <iframe
        ref="previewIframe"
        width="100%"
        style="height: calc(100vh - 180px)"
        :src="previewSrc"
      />
    </div>
  </a-modal>
</template>
<script>
export default {
  props: ["visible", "previewSrc", "btnIsLoading"],
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    visible: function () {
      this.iframeLoad();
    },
  },
  methods: {
    closePreview() {
      this.$emit("onCancel");
    },
    // 调用方法
    iframeLoad() {
      this.loading = true;
      this.$nextTick(() => {
        const iframe = this.$refs.previewIframe;
        if (iframe.attachEvent) {
          // IE
          iframe.attachEvent("onload", () => {
            this.loading = false;
          });
        } else {
          // 非IE
          iframe.onload = () => {
            this.loading = false;
          };
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
iframe {
  border: 1px solid #dbdbdb;
  border-radius: 3px;
}
</style>